import React from 'react';
import { FiMapPin, FiPhone, FiMail, FiInstagram, FiFacebook, FiLinkedin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-brand-black text-white pt-20 pb-10 border-t border-white/10">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">

          {/* Brand Col */}
          <div className="lg:col-span-1 flex flex-col items-center md:items-start text-center md:text-left">
            <img
              src="/assets/images/logo.png"
              alt="Tanjung Priok Logistik"
              className="h-16 object-contain mb-6 brightness-0 invert opacity-90 mx-auto md:mx-0"
            />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Solusi logistik terintegrasi untuk menjangkau seluruh pelosok dunia. Aman, tepat waktu, dan efisien.
            </p>
            <div className="flex justify-center md:justify-start gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red hover:text-white transition-colors">
                <FiInstagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red hover:text-white transition-colors">
                <FiFacebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-red hover:text-white transition-colors">
                <FiLinkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6 text-white">Tautan Cepat</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="text-gray-400 hover:text-brand-red transition-colors text-sm">Beranda</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-brand-red transition-colors text-sm">Tentang Kami</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-brand-red transition-colors text-sm">Layanan</a></li>
              <li><a href="#network" className="text-gray-400 hover:text-brand-red transition-colors text-sm">Jaringan</a></li>
              <li><a href="#calculator" className="text-gray-400 hover:text-brand-red transition-colors text-sm">Cek Ongkir</a></li>
            </ul>
          </div>

          {/* Services Links */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6 text-white">Layanan Utama</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm">Pengiriman Darat</li>
              <li className="text-gray-400 text-sm">Pengiriman Laut</li>
              <li className="text-gray-400 text-sm">City Courier</li>
              <li className="text-gray-400 text-sm">Pengiriman Udara</li>
              <li className="text-gray-400 text-sm">Trucking & Towing</li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6 text-white">Hubungi Kami</h4>
            <ul className="space-y-4 flex flex-col items-center md:items-start">
              <li className="flex flex-col md:flex-row items-center md:items-start gap-3 text-gray-400 text-sm">
                <FiMapPin className="text-brand-red mt-1 flex-shrink-0" size={18} />
                <span>Komp. Skarda N No. 09 Gunung Sari, Rappocini Kota Makassar, Sulawesi Selatan.</span>
              </li>
              <li className="flex flex-col md:flex-row items-center gap-3 text-gray-400 text-sm">
                <FiPhone className="text-brand-red flex-shrink-0" size={18} />
                <span>0823-1526-8197</span>
              </li>
              <li className="flex flex-col md:flex-row items-center gap-3 text-gray-400 text-sm">
                <FiMail className="text-brand-red flex-shrink-0" size={18} />
                <span>tanjungprioklogistik@gmail.com</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm text-center md:text-left">
            &copy; Tanjung Priok Logistik. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;